export const CITY_COORDS: Record<string, [number, number]> = {
  // 直辖市
  北京: [39.9042, 116.4074],
  上海: [31.2304, 121.4737],
  天津: [39.0842, 117.2010],
  重庆: [29.5637, 106.5516],

  // 广东
  广州: [23.1291, 113.2644],
  深圳: [22.5431, 114.0579],
  东莞: [23.0208, 113.7517],
  佛山: [23.0219, 113.1219],
  珠海: [22.2710, 113.5767],
  中山: [22.5176, 113.3926],
  惠州: [23.1110, 114.4148],
  汕头: [23.3535, 116.6820],
  茂名: [21.6630, 110.9256],
  湛江: [21.2707, 110.3594],
  清远: [23.6990, 113.0560],
  汕尾: [22.7740, 115.3750],
  揭阳: [23.5499, 116.3727],

  // 江苏
  南京: [32.0603, 118.7969],
  苏州: [31.2990, 120.5853],
  无锡: [31.4912, 120.3119],
  常州: [31.7720, 119.9738],
  南通: [31.9797, 120.8944],
  连云港: [34.5965, 119.2218],
  宿迁: [33.9634, 118.2752],
  淮安: [33.5500, 119.0218],
  盐城: [33.3475, 120.1617],
  扬州: [32.3935, 119.4129],
  镇江: [32.1884, 119.4245],
  泰州: [32.4554, 119.9231],
  徐州: [34.2044, 117.2847],

  // 浙江
  杭州: [30.2741, 120.1551],
  宁波: [29.8683, 121.5440],
  温州: [28.0005, 120.6719],
  金华: [29.0790, 119.6474],
  嘉兴: [30.7522, 120.7550],
  绍兴: [30.0300, 120.5800],
  台州: [28.6561, 121.4207],
  湖州: [30.8924, 120.0876],
  丽水: [28.4672, 119.9218],
  舟山: [29.9859, 122.2065],
  衢州: [28.9353, 118.8739],

  // 四川
  成都: [30.5728, 104.0668],
  绵阳: [31.4679, 104.6796],
  德阳: [31.1271, 104.3975],
  乐山: [29.5525, 103.7659],
  宜宾: [28.7530, 104.6421],
  泸州: [28.8717, 105.4418],
  自贡: [29.3390, 104.7784],
  攀枝花: [26.5825, 101.7189],
  广元: [32.4356, 105.8443],
  南充: [30.7952, 106.0826],
  广安: [30.4548, 106.6318],
  达州: [31.2094, 107.4673],
  眉山: [30.0766, 103.8484],
  巴中: [31.8680, 106.7472],

  // 湖北
  武汉: [30.5928, 114.3055],
  宜昌: [30.6920, 111.2864],
  荆州: [30.3353, 112.2396],
  黄石: [30.2159, 115.0388],
  襄阳: [32.0224, 112.1220],
  鄂州: [30.3906, 114.8948],

  // 湖南
  长沙: [28.2282, 112.9388],
  株洲: [27.8275, 113.1332],
  湘潭: [27.8272, 112.9445],
  岳阳: [29.3572, 113.1288],
  常德: [29.0318, 111.6966],
  衡阳: [26.8982, 112.5718],

  // 山东
  济南: [36.6512, 117.1201],
  青岛: [36.0671, 120.3826],
  烟台: [37.4638, 121.4479],
  潍坊: [36.7064, 119.1616],
  临沂: [35.0471, 118.3564],
  济宁: [35.4150, 116.5871],
  东营: [37.4346, 118.6748],
  威海: [37.5135, 122.1217],

  // 陕西
  西安: [34.3416, 108.9398],
  咸阳: [34.3298, 108.7093],
  宝鸡: [34.3616, 107.2378],
  延安: [36.5853, 109.4891],
  汉中: [33.0670, 107.0260],

  // 河南
  郑州: [34.7466, 113.6253],
  洛阳: [34.6197, 112.4540],
  开封: [34.7976, 114.3071],
  南阳: [32.9987, 112.5294],

  // 河北
  石家庄: [38.0428, 114.5149],
  唐山: [39.6308, 118.1803],
  保定: [38.8671, 115.4641],
  廊坊: [39.5380, 116.6836],
  邯郸: [36.6252, 114.5388],
  张家口: [40.8244, 114.8840],
  秦皇岛: [39.9355, 119.5993],
  承德: [40.9515, 117.9634],

  // 辽宁
  沈阳: [41.8057, 123.4315],
  大连: [38.9140, 121.6147],
  鞍山: [41.1074, 122.9953],
  抚顺: [41.8796, 123.9574],
  本溪: [41.2934, 123.7690],
  锦州: [41.0950, 121.1269],

  // 黑龙江
  哈尔滨: [45.8038, 126.5349],
  大庆: [46.5898, 125.1031],
  齐齐哈尔: [47.3547, 123.9181],
  牡丹江: [44.5524, 129.6328],

  // 吉林
  长春: [43.8171, 125.3235],
  吉林: [43.8378, 126.5497],

  // 山西
  太原: [37.8706, 112.5489],
  大同: [40.0768, 113.2956],

  // 安徽
  合肥: [31.8206, 117.2272],
  芜湖: [31.3523, 118.4330],
  马鞍山: [31.6668, 118.5065],
  蚌埠: [32.9168, 117.3888],
  阜阳: [32.8997, 115.8147],

  // 福建
  福州: [26.0745, 119.2965],
  厦门: [24.4798, 118.0894],
  泉州: [24.8741, 118.6757],
  莆田: [25.4314, 119.0077],
  漳州: [24.5137, 117.6534],

  // 江西
  南昌: [28.6820, 115.8579],
  九江: [29.7050, 115.9929],
  赣州: [25.8308, 114.9337],
  景德镇: [29.2693, 117.1788],

  // 广西
  南宁: [22.8170, 108.3665],
  柳州: [24.3258, 109.4281],
  桂林: [25.2736, 110.2990],

  // 云南
  昆明: [24.8801, 102.8329],
  曲靖: [25.4898, 103.7966],
  玉溪: [24.3519, 102.5469],
  丽江: [26.8721, 100.2297],
  普洱: [22.7879, 100.9721],

  // 贵州
  贵阳: [26.6470, 106.6302],
  遵义: [27.7256, 106.9271],

  // 甘肃
  兰州: [36.0611, 103.8343],
  天水: [34.5814, 105.7247],

  // 内蒙古
  呼和浩特: [40.8420, 111.7497],
  包头: [40.6578, 109.8404],
  鄂尔多斯: [39.6086, 109.7816],

  // 新疆
  乌鲁木齐: [43.8256, 87.6168],
  喀什: [39.4702, 75.9905],
  克拉玛依: [45.5798, 84.8893],

  // 海南
  海口: [20.0446, 110.1999],
  三亚: [18.2523, 109.5118],

  // 宁夏
  银川: [38.4875, 106.2309],
  吴忠: [37.9974, 106.1986],
  固原: [36.0037, 106.2425],

  // 青海
  西宁: [36.6232, 101.7782],

  // 西藏
  拉萨: [29.6521, 91.1321],

  // 其他
  日照: [35.4164, 119.5269],
  菏泽: [35.2333, 115.4807],
  滨州: [37.3797, 117.9707],
  朔州: [39.3367, 112.4332],
  忻州: [38.4157, 112.7340],
  晋城: [35.4900, 112.8516],
  晋中: [37.6926, 112.7528],
  吕梁: [37.5190, 111.1426],
  阳泉: [37.8566, 113.5796],
  运城: [35.0260, 111.0073],
  临汾: [36.0882, 111.5190],
  长治: [36.1954, 113.1163],
  朝阳: [41.5676, 120.4516],
  盘锦: [41.1208, 122.0705],
  丹东: [40.1291, 124.3954],
  铁岭: [42.2990, 123.8442],
  营口: [40.6673, 122.2330],
  阜新: [42.0219, 121.6627],
  辽阳: [41.2693, 123.1953],
};

export const DEFAULT_CITY = '\u5317\u4eac';
export const DEFAULT_ZOOM = 12;
